<app-page-container>
  <div class="opcoes">
    <div class="titulo">
      <span>Boletos</span>
    </div>

    <div class="sub-titulo my-2" *ngIf="autorizacoes.listarBoletos">
      <p class="titulo-filtro">
        Filtrar
      </p>
    </div>

    <form [formGroup]="form" class="form-filtro-boleto" *ngIf="autorizacoes.listarBoletos">
      <div class="cliente">
        <label class="label__clientes">Cliente:</label>
        <select class="form-select" formControlName="codCliente">
          <option [ngValue]="''" selected>
            Selecionar
          </option>
          <div *ngIf="environment.company === 'apnetworks'; then apnetworksCliente else kmDoBrasilCliente"></div>
          <ng-template #apnetworksCliente>
            <option *ngFor="let cliente of clientes.registros" [ngValue]="cliente.codigo">
              {{ cliente.codigo }} - {{ cliente.nome || cliente.fantasia || 'Sem dados'}}
            </option>
          </ng-template>
          <ng-template #kmDoBrasilCliente>
            <option *ngFor="let cliente of clientes.registros" [ngValue]="cliente.codigo">
              {{ cliente.codigo }} - {{ cliente.fantasia || cliente.nome || 'Sem dados'}}
            </option>
          </ng-template>
        </select>
      </div>

      <div class="conjunto">
        <div class="tipo">
          <label class="label__clientes">Tipo:</label>
          <div class="div-checkbox">
            <div class="radio">
              <input type="radio" value="emAtraso" formControlName="situacao">
              <label> Em atraso</label>
            </div>
            <div class="radio">
              <input type="radio" value="aVencer" formControlName="situacao">
              <label>À Vencer</label>
            </div>
            <div class="radio">
              <input type="radio" value="pago" formControlName="situacao">
              <label> Pago</label>
            </div>
            <div class="radio">
              <input type="radio" value="todos" formControlName="situacao">
              <label> Todos</label>
            </div>
          </div>
        </div>

        <div class="busca">
          <button class="btn btn-primary" type="button" (click)="getBoleto(true)">Buscar</button>
        </div>
      </div>
    </form>
    <div class="mobile">
      <div class="mobile-table">
        <app-item-boleto-mobile *ngFor="let boleto of boletos.registros" [boleto]="boleto"></app-item-boleto-mobile>
      </div>
    </div>
    <div class="desktop">
      <app-tabela
        [cabecalhos]="['Título', 'Origem', 'Data', 'Vencimento', 'Cliente', 'Valor Bruto', 'Valor Descontado', 'Situação', 'Ações']"
        [items]="boletos.registros" [colunasOcultas]="['Ações']"
        [condicoesColunas]="[{ columnName: 'Ações', condition: autorizacoes.realizarDownloadBoleto }]">
        <tr *ngFor="let boleto of boletos.registros">
          <td>{{boleto.codFatura}}</td>
          <td>{{boleto.origem || 'Sem dados'}}</td>
          <td>{{boleto.data | date: "dd/MM/yyyy hh:mm" || 'Sem dados'}}</td>
          <td>{{boleto.venc | date: "dd/MM/yyyy hh:mm" || 'Sem dados'}}</td>
          <div *ngIf="environment.company === 'apnetworks'; then apnetworksCliente else kmDoBrasilCliente"></div>
          <ng-template #apnetworksCliente>
            <td #ref [matTooltip]="boleto.nomeCliente ||
              boleto.nomeFantasiaCliente || 'Sem dados'" matTooltipClass="u-margin-0"
              [matTooltipDisabled]="!excedeTamanho(ref)">{{boleto.nomeCliente ||
              boleto.nomeFantasiaCliente || 'Sem dados'}}
            </td>
          </ng-template>
          <ng-template #kmDoBrasilCliente>
            <td #ref [matTooltip]="boleto.nomeFantasiaCliente ||
              boleto.nomeCliente || 'Sem dados'" matTooltipClass="u-margin-0"
              [matTooltipDisabled]="!excedeTamanho(ref)">{{boleto.nomeFantasiaCliente ||
              boleto.nomeCliente || 'Sem dados'}}
            </td>
          </ng-template>
          <td>{{boleto.vlrBruto| currency : 'BRL' || 'Sem dados'}}</td>
          <td>{{boleto.vlrDesconto | currency : 'BRL' || 'Sem dados'}}</td>
          <td>{{boleto.situacao}}</td>
          <td class="download" *ngIf="autorizacoes.realizarDownloadBoleto">
            <button (click)="openModal(boleto)">Download</button>
          </td>
        </tr>
      </app-tabela>
    </div>
  </div>
  <app-paginacao nomeDaLista="Boletos" [(dados)]="boletos" (dadosChange)="getBoleto()"
    *ngIf="this.boletos.registros.length !== 0"></app-paginacao>
</app-page-container>

<ng-template #retornoOSNA>Não há registros.</ng-template>
<app-modal-download-boleto (closeModal)="closeModal()" (confirm)="downloadBoleto($event)"></app-modal-download-boleto>